import React from 'react';
import minus from '../../assets/minus.png';
import './styles.css'

const defaultButtonStyles = {
  position: 'absolute',
  fontSize: '16px',
  right: '15px',
  color: '#ffffff',
  background: 'none',
  border: 0,
  fontWeight: 'bold',
  lineHeight: '40px',
  height: '40px',
  cursor: 'pointer',
  backgroundColor: '#121D22',

};

const defaultHeaderStyles = {
  lineHeight: '40px',
  paddingLeft: '15px',
  height: '40px',
  borderRadius: '8px 8px 0 0',
  backgroundColor: '#121D22',
  color: '#FFFFFF',
  fontSize: '16px',
  fontWeight: 'bold',
  overflow: 'hidden',
  fontFamily: 'Montserrat',
  position: 'relative'
};

const defaultIconStyles = {
  position: 'absolute',
  right: '39px',
  bottom: '6px',
  height: '26px',
  width: '14px',
  zIndex: '999',
  cursor: 'pointer',
}

const Header = ({
  headerText,
  headerBtnText,
  handleCloseWithoutSave,
  handleCloseWithSave,
  headerStyles,
  headerBtnStyles,
  iconStyles
}) => (
  <div style={headerStyles}>
    {headerText}
    <span></span>
    {/* <img onClick={handleCloseWithSave} src={minus} alt="feedback icon" 
     style={iconStyles}
     /> */}
    <button onClick={handleCloseWithoutSave} style={headerBtnStyles} type="button">
      {headerBtnText}
    </button>
  </div>
);

Header.defaultProps = {
  headerText: window.location.href.includes('QuickPay') ? 'Feedback' : 'Feedback',
  headerBtnText: 'X',
  headerBtnStyles: defaultButtonStyles,
  headerStyles: defaultHeaderStyles,
  iconStyles: defaultIconStyles
};

export default Header;
